const wrapper = "_yr2w1v9fqyk";
const text = "_yr2t1n03zos";
const count = "_yr2c1cfkk83";

export { count, text, wrapper };
import "./notification-badge.style.linaria.module.css";
//# sourceMappingURL=notification-badge.style.js.map
